export default __webpack_public_path__ + "static/media/WM0440.34I-43834_-26160_0.0dab5b5e.jpg";